// extracted by mini-css-extract-plugin
export default {"projectTile":"ProjectTile_projectTile__tdluz"};